import { Injectable } from '@angular/core';
import { LMListSpecUtilService } from '@list/services';

/**
 * Use this util service to compute things based off of a listSpec.
 */
@Injectable()
export class LMPageSpecUtilService {

  constructor(private lmListSpecUtilService: LMListSpecUtilService) {}

  public allowUpdate(pageSpec: LMPageSpec): boolean {
    for (let i = 0, len = pageSpec.pageSpec.panels.length; i < len; i++) {
      const pagePanelSpec: LMPagePanelSpec = pageSpec.pageSpec.panels[i];

      if (pagePanelSpec.panelType === 'MultiPanePanel') {
        for (const pane of pagePanelSpec.panes) {
          if (pane.listSpec && this.lmListSpecUtilService.allowUpdate(pane.listSpec)) {
            return true;
          } else if (pane.pane && pane.pane.listSpec && this.lmListSpecUtilService.allowUpdate(pane.pane.listSpec)) {
            return true;
          }
        }

      } else if (pagePanelSpec.panelType === 'Panel') {
        const pane = pagePanelSpec.pane;
        if (pane.listSpec && this.lmListSpecUtilService.allowUpdate(pane.listSpec)) {
          return true;
        }

      } else if (pagePanelSpec.panelType === 'DashBoardPanel') {
        for (const pane of pagePanelSpec.panes) {
          if (pane.listSpec && this.lmListSpecUtilService.allowUpdate(pane.listSpec)) {
            return true;
          }
        }

      } else if (pagePanelSpec.panelType === 'WorkViewPanel') {
        // not implemented in 4.x
      }
    }
    return false;
  }
}
